import Cookies from "js-cookie";
import { responseNotification } from "../../utils/notify";
import { LOGIN_REQUEST, LOGIN_SUCCESS } from "./authType";

export const login = async (
  dispatch: (arg0: { type: string; payload?: any }) => void,
  { mobileNumber, password }: any
) => {
  try {
    dispatch({ type: LOGIN_REQUEST });

    // 1️⃣ Login API
    const loginRes = await fetch(
      `${process.env.REACT_APP_AUTH_API}/merchant/login`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mobileNumber, password }),
      }
    );

    const loginData = await loginRes.json();
    const { token, userType } = loginData;

    if (!token) {
      responseNotification(loginData?.message || "Invalid credentials", "error");
      return false;
    }

    // Save token to cookies (optional)
    Cookies.set("token", token);

    // 2️⃣ Fetch Merchant Shop Info
    const shopRes = await fetch(
      `${process.env.REACT_APP_CATALOG_READER_API}/merchant/all-shops-by-merchant`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const shopData = await shopRes.json();
    const shops = shopData?.shops || [];

    // 3️⃣ Merchant Details API
    let merchant = null;

    if (userType === "SUPER_MERCHANT" || userType === "MERCHANT") {
      const merchantRes = await fetch(
        `${process.env.REACT_APP_RIDER_API}/details`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const merchantInfo = await merchantRes.json();
      merchant = merchantInfo?.merchant;

      if (!merchant) {
        responseNotification("No merchant data found", "error");
        return false;
      }

      // 4️⃣ Dispatch Redux Login
      const payload = {
        ...loginData,
        token,
        merchantInfo: merchant,
        merchantId: merchant?.merchantId,
        shopInfo: shops[0] || null,
        shopId: shops[0]?.id || null,
        iat: new Date(),
      };

      dispatch({
        type: LOGIN_SUCCESS,
        payload,
      });

      // Save to localStorage
      localStorage.setItem("authState", JSON.stringify(payload));

      // 5️⃣ Notify success
      responseNotification(
        merchantInfo?.message?.replace("Operation", "Login") ||
          "Login Successful",
        "success"
      );

      if (merchant?.state === "VERIFIED") return "alreadyMerchant";
      return "newMerchant";
    }

    return true;
  } catch (error) {
    console.log(error);
    responseNotification("Login failed! Something went wrong.", "error");
    return false;
  }
};
